<template>
  <div class="cardSkeleton">
    <div class="cardSkeleton__header">
      <span class="cardSkeleton__line cardSkeleton__line--title" />
      <span class="cardSkeleton__line cardSkeleton__line--actions" />
    </div>
    <span class="cardSkeleton__line cardSkeleton__line--category" />
    <div class="cardSkeleton__image" />
    <div class="cardSkeleton__params">
      <span
        v-for="index in PARAM_LINES_COUNT"
        :key="index"
        class="cardSkeleton__line"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
const PARAM_LINES_COUNT = 4
</script>

<style lang="scss">
.cardSkeleton {
  background: #fff;
  border-radius: 10px;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 12px;

  &__header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 16px;
  }

  &__line {
    display: block;
    height: 14px;
    border-radius: 4px;
    background: linear-gradient(90deg, #EEF1F4 25%, #F7F9FA 50%, #EEF1F4 75%);
    background-size: 200% 100%;
    animation: cardSkeleton-shimmer 1.4s ease-in-out infinite;

    &--title {
      width: 40%;
      height: 18px;
    }

    &--actions {
      width: 48px;
    }

    &--category {
      width: 65%;
    }
  }

  &__image {
    height: 180px;
    border-radius: 10px;
    background: linear-gradient(90deg, #EEF1F4 25%, #F7F9FA 50%, #EEF1F4 75%);
    background-size: 200% 100%;
    animation: cardSkeleton-shimmer 1.4s ease-in-out infinite;
  }

  &__params {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }
}

@keyframes cardSkeleton-shimmer {
  0% {
    background-position: 200% 0;
  }

  100% {
    background-position: -200% 0;
  }
}

</style>
